<template>
  <div class="border-b border-gray-300 py-5 grid gap-2">
    <div class="flex flex-row gap-4 justify-between">
      <span class="font-sans font-medium text-lg flex-grow">{{ name }}</span>
      <button class="" @click="emit('remove')">
        <CommonFontAwesomeIcon
          icon="fa-regular fa-close"
          class="w-4 h-4 text-black opacity-50 hover:opacity-100 hover:cursor-pointer"
        />
      </button>
    </div>
    <div class="flex flex-row justify-between items-end">
      <span v-if="inWaitingPeriod" class="font-sans text-gray-600 text-sm">{{
        $t('yourTrialIsOver')
      }}</span>
      <span v-else class="font-sans text-blue text-sm">{{
        $t('14DayFreeTrial')
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  name: string
  inWaitingPeriod: boolean
}>()

const emit = defineEmits<{
  (e: 'remove'): void
}>()
</script>
